import { Text } from '@consta/uikit/Text'

import css from './SpeedLaws.css'

export const titleCellRender = (text: string) => (
  <Text className={css.titleCell} size="xs" view="ghost" weight="medium">
    {text}
  </Text>
)
